import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 * @extends JetView
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions for the DataTable
                                {
                                    id: 'detailTittle', // Unique ID for the column
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'Id', // Unique ID for the column
                                    header: 'Id', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PlayerId', // Unique ID for the column
                                    header: _('ID Usuario'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Unique ID for the column
                                    header: _('Usuario (Correo electrónico)'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Unique ID for the column
                                    header: _('Estado'), // Localized column header
                                    options: [
                                        // Dropdown options for the column
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Unique ID for the column
                                    header: _('Tipo'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Product', // Unique ID for the column
                                    header: _('Producto'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Category', // Unique ID for the column
                                    header: _('Categorías'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SubCategory', // Unique ID for the column
                                    header: _('Sub Categoría'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Game', // Unique ID for the column
                                    header: _('Juego'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FinalDate', // Unique ID for the column
                                    header: _('Fecha final de la autoexclusión'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 250, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'Reason', // Unique ID for the column
                                    header: _('Motivo Autoexclusión'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AutoAmount', // Unique ID for the column
                                    header: _('Numero Autoexclusiónes'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserCreation', // Unique ID for the column
                                    header: _('Usuario Creación'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserModified', // Unique ID for the column
                                    header: _('Usuario Modificó'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for clicking on details icon
                                details: function (euv, id) {
                                    vthis.app.callEvent('user:id', id); // Trigger event with user ID
                                },
                            },
                            on: {
                                // Event handlers for the DataTable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                                    this.showOverlay(
                                        // Show no data overlay
                                        _("<div style='margin:75px; font-size:18px;'>No hay datos</div>"),
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        grid = $$('datatable'); // Get the DataTable instance
        var url = devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion?Partner=' + id_partner + '&'; // Base URL for API requests
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to query
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for row selection
        grid.attachEvent('onAfterSelect', (obj) => {
            this.app.callEvent('user:id', [obj.Id]); // Trigger event with selected user ID
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                devConfig.geturlApi() +
                    'null/Report/getRegisteredAutoexclusion?Partner=' +
                    id_partner +
                    '&' +
                    '?start=0&count=' +
                    grid.data.$pagesize +
                    '&PlayerId=' +
                    id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
